<template>
    <el-row :gutter="10" style="padding:30px 30px 10px 30px;">
        <el-col :span="8">
            <el-card shadow="always">
                <router-link :to="global.hasRight('payments', 'approver') || global.hasRight('payments', 'statistician') ? 
                    '/payment/allPaymentList' : '/payment/myPaymentList'">
                    <i class="fa fa-credit-card"></i> Payments</router-link>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link :to="global.hasRight('expense', 'approver') || global.hasRight('expense', 'statistician') ? 
                    '/expense/allExpenseList' : '/expense/myExpenseList'">
                    <i class="fa fa-credit-card"></i> Expense</router-link>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link :to="global.hasRight('printing-procurement', 'approver') || global.hasRight('printing-procurement', 'statistician') ?
                    '/procurement/allProcurementList' : '/procurement/myProcurementList'">
                    <i class="fa fa-print"></i> Printing / Procurement</router-link>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link :to="global.hasRight('personal-investment', 'approver') ? 
                    '/investment/allInvestmentList' : '/investment/myInvestmentList'">
                    <i class="fa fa-line-chart"></i> Personal Investment</router-link>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link to="/report/reportList">
                    <i class="fa fa-wpforms"></i> Monthly Report</router-link>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link :to="global.hasRight('event-interview', 'approver') ? 
                    '/log/allEventList' : '/log/myEventList'">
                    <i class="fa fa-group"></i> Event Log</router-link>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link :to="global.hasRight('event-interview', 'approver') ? 
                    '/log/allInterviewList' : '/log/myInterviewList'">
                    <i class="fa fa-microphone"></i> Interview (Media) Log</router-link>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link v-if="global.hasAuth('premia-user')" to="/auth/userList">
                <i class="fa fa-user"></i> User Management</router-link>
                <span v-else class="noAuth"><i class="fa fa-user"></i> User Management</span>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link v-if="global.hasAuth('companyDocs')" to="/companyDoc/allCompanyDocs">
                    <i class="fa fa-archive"></i>  Company Documents</router-link>
                <span v-else class="noAuth"><i class="fa fa-archive"></i> Company Documents</span>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <router-link :to="global.hasRight('deck-docs', 'compliance') ? 
                    '/deck/allDeckDocuments':'/deck/myDeckDocuments'">
                    <i class="fa fa-file-text-o"></i> Deck Documents
                </router-link>
            </el-card>
        </el-col>

        <el-col :span="8">
            <el-card shadow="always">
                <a v-if="global.hasAuth('insight-publish')" :href="global.cms_domain+'/insight/insightWorkflowList'" target="_blank">
                    <i class="fa fa-file-text"></i> Insight Workflow</a>
                <span v-else class="noAuth"><i class="fa fa-file-text"></i> Insight Workflow</span>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <a v-if="global.hasRight('website-backend')" :href="global.cms_domain">
                    <i class="fa fa-television"></i> Website Backend</a>
                <span v-else class="noAuth"><i class="fa fa-television"></i> Website Backend</span>
            </el-card>
        </el-col>
        
        <el-col :span="8">
            <el-card shadow="always">
                <a v-if="global.hasRight('announcement-workflow')" 
                    href="https://cms.premia-partners.com/announcement/announcementWorkflowList">
                    <i class="fa fa-sticky-note-o"></i> Announcement Workflow</a>
                <span v-else class="noAuth"><i class="fa fa-sticky-note-o"></i> Announcement Workflow</span>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <a v-if="global.hasRight('meeting-report', 'creator')" :href="'/iss/topHoldingBallots'">
                    <i class="fa fa-envelope-o"></i> ISS Meeting Report</a>
                <span v-else class="noAuth"><i class="fa fa-envelope-o"></i> ETF email template</span>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <a v-if="global.hasRight('dividend-workflow')" 
                    href="https://cms.premia-partners.com/dividend/dividendWorkflowList">
                    <i class="fa fa-wpforms"></i> Dividend Workflow</a>
                <span v-else class="noAuth"><i class="fa fa-wpforms-o"></i> Dividend Workflow</span>
            </el-card>
        </el-col>
        <el-col :span="8">
            <el-card shadow="always">
                <a v-if="global.hasRight('create-redeem', 'admin')" href="https://cms.premia-partners.com/createRedeem/createRedeemList">
                    <i class="fa fa-credit-card"></i> Creation / Redemption</a>
                <span v-else class="noAuth"><i class="fa fa-credit-card"></i> Creation / Redemption</span>
            </el-card>
        </el-col>

        <el-col :span="8">
            <el-card shadow="always">
                <a href="https://pp-tools.premia-partners.com/" target="_blank">
                    <i class="fa fa-wpforms"></i> PP-Tools</a>
            </el-card>
        </el-col>

        <el-col :span="8" v-if="todoList.isApprover || todoList.isCompliance" >
            <el-card shadow="always">
                <el-popover placement="bottom-start" :width="400" trigger="hover">
                    <template #reference>
                        <a href="#"> 
                            <i class="fa fa-list-alt"></i> {{todoList.isApprover?'Approver':'Compliance'}} Todo List
                            <sup v-if="Object.keys(todoList).length > 1" class="dot">●</sup>
                        </a>
                    </template>
                    <template #default>
                        <div class="todos" v-if="todoList.isApprover">
                            <router-link to="/procurement/allProcurementList?action=review">
                                <span>Printing / Procurement</span><sup v-if="todoList.workflow">{{todoList.workflow}}</sup>
                            </router-link>
                            <router-link to="/expense/allExpenseList?status=Pending+Approval">
                                <span>Expense</span><sup v-if="todoList.expense">{{todoList.expense}}</sup>
                            </router-link>
                            <router-link to="/payment/allPaymentList?action=review">
                                <span>Payments</span><sup v-if="todoList.payments">{{todoList.payments}}</sup>
                            </router-link>
                            <router-link to="/log/allInterviewList?action=review">
                                <span>Interview (Media)</span><sup v-if="todoList.interview">{{todoList.interview}}</sup>
                            </router-link>
                            <router-link to="/log/allEventList?action=review">
                                <span>Event</span><sup v-if="todoList.event">{{todoList.event}}</sup>
                            </router-link>
                        </div>
                        <div class="todos" v-else>
                            <a :href="global.cms_domain+'/insight/insightWorkflowList'">
                                <span>Insight Workflow</span><sup v-if="todoList.insight">{{todoList.insight}}</sup>
                            </a>
                            <a :href="global.cms_domain+'/weekly/weeklyList'">
                                <span>Weekly Chart</span><sup v-if="todoList.weekly">{{todoList.weekly}}</sup>
                            </a>
                            <a :href="global.cms_domain+'/webinar/webinarList'">
                                <span>Webinar</span><sup v-if="todoList.webinar">{{todoList.webinar}}</sup>
                            </a>
                            <a :href="global.cms_domain+'/notForPublish/articleList'">
                                <span>NotForPublish</span><sup v-if="todoList.notForPublish">{{todoList.notForPublish}}</sup>
                            </a>
                            <router-link to="/investment/allInvestmentList?action=review">
                                <span>Personal Investments</span><sup v-if="todoList.investment">{{todoList.investment}}</sup>
                            </router-link>
                            <router-link to="/deck/allDeckDocuments?action=review">
                                <span>Deck Documents</span><sup v-if="todoList.deck">{{todoList.deck}}</sup>
                            </router-link>
                            <router-link to="/companyDoc/allCompanyDocs?action=review" v-if="todoList.companyDocs">
                                <span>Company Documents</span><sup v-if="todoList.companyDocs">{{todoList.companyDocs}}</sup>
                            </router-link>
                            <router-link to="/report/reportList">
                                <span>Monthly Reports</span><sup v-if="todoList.report">{{todoList.report}}</sup>
                            </router-link>
                        </div>
                    </template>
                </el-popover>
            </el-card>
        </el-col>

    </el-row>

    <el-row>
        <el-col :span="24" :gutter="10" style="padding:0px 30px;">
            <el-card class="box-card" style="font-size:14px;">
                <template #header>
                    <div class="card-header">
                        <span>Other Links</span>
                    </div>
                </template>
                <el-row style="padding:10px;">
                    <el-col :span="8">
                        <a href="https://robo.premia-partners.com/tools/news/fund_holdings_news.jsp" target="_blank">
                            <b>Finance News for Holdings</b></a>
                    </el-col>
                    <el-col :span="8">
                        <a v-if="global.hasRight('bond-data', 'research')" 
                            href="https://etfprod.premia-partners.com/admin/export_etf_data.jsp" target="_blank"><b>Export ETF Data</b></a> |  
                        <a :href="global.robo_domain" target="_blank"><b>Robo Website</b></a> | 
                        <a href="https://etfprod.premia-partners.com/admin/etfHoldings" target="_blank"><b>ETF Holdings</b></a>
                    </el-col>
                    <el-col :span="8">
                        <template v-if="global.hasRight('website-backend', 'admin')">
                           <a href="https://etfprod.premia-partners.com/admin/" target="_blank"><b>Admin Page</b></a> |
                        </template>
                        <template v-if="global.hasRight('insight-publish', 'confirm') || global.hasRight('insight-publish', 'admin')">
                            <a href="https://etfprod.premia-partners.com/page_refresh.jsp" target="_blank"><b>Refresh Website</b></a> |
                        </template>
                        <a href="https://etfprod.premia-partners.com/admin/chinese.jsp" target="_blank"><b>简/繁转换</b></a>
                    </el-col>
                </el-row>
            </el-card>
        </el-col>
    </el-row>
</template>

<script>
import 'font-awesome/css/font-awesome.min.css';
import AXIOS from '@/common/axios.js';
import global from '@/common/global.js'
const leafletFunds = "CXBS:2803|CXNE:3173|AITE:3181|EATE:2810|MVTE:2804|FRNE:3077|CTBE:2817|CPBE:3001|STRE:3151|JPBE:3411|FTWE:3453|SUKE:3478".split("|");
const factsheetFunds="CXBS:2803|CXNE:3173|AITE:3181|EATE:2810|MVTE:2804|FRNE:3077|FRNA:9078|CTBE:2817|CPBE:3001|STRE:3151|CTB2:9177|JPBE:3411|FTWE:3453|FTWA:9159|SUKE:3478".split("|");
const languages = [{key:"en",value:"EN"}, {key:"cn", value:"SC"}, {key:"hk", value:"TC"}];

export default {
    data() {
        return {
            languages, factsheetFunds, leafletFunds,
            todoList: {},
            global,
        }
    },
    async mounted() {
        let result = await AXIOS('/user/getTodoList', null);
        if (result.success) {
            this.todoList = result.data;
        } else {
            console.log("getTodoList failed " + result.errMsg);
        }
    }
}
</script>

<style scoped>
    .content {
        height: calc(100% - 92px);
    }
    .el-card__body i {
        font-size:40px; height:40px; vertical-align: middle; margin-right:8px;
    }
    .el-card__body a {
        text-decoration: none;
        color:rgb(0,113,189);
    }
    .el-card__body span {
        color:#999;
    }
    .el-card {
        margin: 10px;
    }
    .el-card:hover {
        background:#f8f8f8; 
    }
    .el-card i:hover, .el-card a:hover {
        color:#01b1af;
    }
    .noAuth {
        cursor: not-allowed;
        color:#bbb;
    }
    .dot {
        color:#e50;
        font-size:20px;
    }
    .todos a {
        display:block;
        padding:8px 20px;
        text-decoration: none;
        color:#269;
    }
    .todos sup {
        background:#e50;
        color:#fff;
        margin-left:3px;
        padding:1px 5px;
        border-radius: 8px;
        font-size:11px;
    }
    .todos a:hover {
        background:#f0f6ff;
    }
</style>
